import { USER_LOGOUT_CLEAR } from 'constants/ActionTypes';
import * as authTypes from 'modules/auth/actionTypes';
import { LOGIN_STEPS } from 'modules/auth/constant';
import { createReducer } from 'utils/ReduxUtils';

import * as usersTypes from '../../actionTypes';

const initialState = false;

/**
 * @returns {boolean}
 */
const handleRequest = () => true;

/**
 * @returns {boolean}
 */
const handleReset = () => false;

/**
 * Stop loading on auth step change (except LOGIN step)
 * @param {boolean} state
 * @param {import('modules/auth/types').SetAuthStepAction} action
 * @returns {boolean}
 */
const handleSetAuthStep = (state, action) => {
  if (action.payload?.step !== LOGIN_STEPS.LOGIN) {
    return false;
  }
  return state;
};

export default createReducer(initialState, {
  // Start loading on requests
  [authTypes.SIGN_IN_REQUEST]: handleRequest,
  [authTypes.SIGN_OUT_REQUEST]: handleRequest,
  [authTypes.IMPERSONATE_USER_ID]: handleRequest,
  [authTypes.LOAD_SESSION_REQUEST]: handleRequest,
  [authTypes.STOP_IMPERSONATE_USER_ID]: handleRequest,
  [usersTypes.CURRENT_USER_DATA_REQUEST]: handleRequest,

  // Stop loading on success
  [authTypes.SIGN_IN_SUCCESS]: handleReset,
  [authTypes.SIGN_OUT_SUCCESS]: handleReset,
  [authTypes.LOAD_SESSION_SUCCESS]: handleReset,
  [usersTypes.CURRENT_USER_DATA_SUCCESS]: handleReset,

  // Stop loading on failures
  [authTypes.SIGN_IN_FAILURE]: handleReset,
  [authTypes.SIGN_OUT_FAILURE]: handleReset,
  [authTypes.LOAD_SESSION_FAILURE]: handleReset,
  [usersTypes.CURRENT_USER_DATA_FAILURE]: handleReset,
  [authTypes.IMPERSONATE_USER_ID_FAILURE]: handleReset,
  [authTypes.STOP_IMPERSONATE_USER_ID_FAILURE]: handleReset,

  // Stop loading on auth step change
  [USER_LOGOUT_CLEAR]: handleSetAuthStep,
  [authTypes.SET_AUTH_STEP]: handleSetAuthStep,
  [authTypes.SIGN_OUT_EMERGENCY]: handleSetAuthStep,
});
